import React from 'react';
import { getAppDomain, AppDomain } from './domainRouter';
import { SafeSuspense } from '@shared/components/SafeSuspense';
import { lazyWithRetry } from '@shared/utils/lazyWithRetry';

const AppMobile = lazyWithRetry(() => import('@app/AppMobile').then(m => ({ default: m.AppMobile })));
const ManagerApp = lazyWithRetry(() => import('@manager/ManagerApp').then(m => ({ default: m.ManagerApp })));
const AccountRegistrationPage = lazyWithRetry(() => 
  import('../account-registration/AccountRegistrationPage').then(m => ({ default: m.AccountRegistrationPage }))
);

/**
 * AppRouter
 * 
 * Componente raiz que decide qual aplicação renderizar com base no domínio.
 * Utiliza React.lazy e SafeSuspense para separação de bundle (Advanced Bundle Splitting).
 */
export const AppRouter: React.FC = () => {
  const domain = getAppDomain();

  return (
    <SafeSuspense>
      {domain === AppDomain.REGISTRATION ? (
        <AccountRegistrationPage />
      ) : domain === AppDomain.MANAGER ? (
        <ManagerApp />
      ) : (
        <AppMobile />
      )}
    </SafeSuspense>
  );
};
